import styled from 'styled-components';

export const LanguageWrapper = styled.div`
  > div > div:not([aria-hidden='true']) {
    align-items: center;
    display: flex;
    gap: ${({ theme }) => theme.spacing(2)}px;

    > div {
      width: 10.5rem;
    }
  }
  label > p {
    margin-bottom: 0;
  }
`;
